/**
 * Read the raw JWT from localStorage
 */
export function getToken() {
  return localStorage.getItem('accessToken')
}

/**
 * Decode the JWT stored in localStorage and return its payload as an object.
 */
export function decodeToken() {
  const token = getToken()
  if (!token) return null

  try {
    const payload = token.split('.')[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decodeURIComponent(
      decoded
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    ))
  } catch (e) {
    console.error('Invalid token', e)
    return null
  }
}

/** Get the “role” claim (set in JwtTokenUtil.generateToken) */
export function getRole() {
  const payload = decodeToken()
  return payload?.role ?? null
}

/** Get the “restaurantId” claim (if present) */
export function getRestaurantId() {
  const payload = decodeToken()
  return payload?.restaurantId ? Number(payload.restaurantId) : null
}

export function getRestaurantLongitude() {
  const payload = decodeToken()
  return payload?.restaurantLongitude ?? null
}

export function getRestaurantLatitude() {
  const payload = decodeToken()
  return payload?.restaurantLatitude ?? null
}

/** Get subject/username (the phone) */
export function getUsername() {
  const payload = decodeToken()
  return payload?.sub ?? null
}

/** Get expiration as a JS Date */
export function getExpirationDate() {
  const payload = decodeToken()
  if (!payload?.exp) return null
  // exp is in seconds since epoch
  return new Date(payload.exp * 1000)
}

/** Check if token is expired */
export function isTokenExpired() {
  const expDate = getExpirationDate()
  return !expDate || expDate < new Date()
}